import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { SearchCustomerNotes } from '../../models/models';

@Component({
    selector: 'customer-notes',
    templateUrl: './customer-notes.component.html',
    standalone: false
})
export class CustomerNotes implements OnInit, OnChanges {
    @Input() billToID: number = 0;
    @Input() shipperID: number = 0;
    @Input() consigneeID: number = 0;

    private currBillToID: number = 0;
    private currShipperID: number = 0;
    private currConsigneeID: number = 0;

    public billToNotesList: SearchCustomerNotes[] = [];
    public shipperNotesList: SearchCustomerNotes[] = [];
    public consigneeNotesList: SearchCustomerNotes[] = [];

    constructor(private orderService: OrderService) {
    }

    ngOnInit() {
        this.getCustomerNotes(this.billToID, "billto");
        this.getCustomerNotes(this.shipperID, "shipper");
        this.getCustomerNotes(this.consigneeID, "consignee");
        //console.log("customer-notes:ngOnInit", this.billToID, this.shipperID, this.consigneeID);
    }

    ngOnChanges() {
        if (this.billToID != this.currBillToID) {
            this.billToNotesList = [];
            this.currBillToID = this.billToID;
            this.getCustomerNotes(this.billToID, "billto");
        }
        if (this.shipperID != this.currShipperID) {
            this.shipperNotesList = [];
            this.currShipperID = this.shipperID;
            this.getCustomerNotes(this.shipperID, "shipper");
        }
        if (this.consigneeID != this.currConsigneeID) {
            this.consigneeNotesList = [];
            this.currConsigneeID = this.consigneeID;
            this.getCustomerNotes(this.consigneeID, "consignee");
        }
        //console.log("customer-notes:ngOnChanges", this.billToID, this.shipperID, this.consigneeID);
    }

    private getCustomerNotes(customerID: number, customerType: string) {
        if (customerID > 0) {
            this.orderService.getSearchCustomerNotesByCustomerID(customerID).subscribe(result => {
                var notesList: SearchCustomerNotes[] = result.resultCollection;
                notesList = notesList.filter(t => t.noteType == "Operational Notes");
                if (customerType == "billto") {
                    this.billToNotesList = notesList;
                }
                else if (customerType == "shipper") {
                    this.shipperNotesList = notesList;
                }
                else if (customerType == "consignee") {
                    this.consigneeNotesList = notesList;
                }
            });
        }
    }
}
